import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { useDispatch as useAppDispatch } from "react-redux";
import persistReducer from "redux-persist/es/persistReducer";
import persistStore from "redux-persist/es/persistStore";
import storage from "redux-persist/lib/storage";
import createOrganizationReducer from "../modules/account-manaement/organizations/redux/slices/create-organization-slice";
import editOrgReducer from "../modules/account-manaement/organizations/redux/slices/edit-organization-slice";
import OrganizationsReducer from "../modules/account-manaement/organizations/redux/slices/organizations-slice";
import createPermissioinsRouteReducer from "../modules/account-manaement/permissions/redux/slices/create-permission-route-slice";
import editPermissioinsRouteReducer from "../modules/account-manaement/permissions/redux/slices/edit-permission-route-slice";
import routesListReducer from "../modules/account-manaement/permissions/redux/slices/permissions-route-list-slice";
import permissionsReducer from "../modules/account-manaement/permissions/redux/slices/permissions-slice";
import ummappedRouteListReducer from "../modules/account-manaement/permissions/redux/slices/permissions-unmapped-routes-slice";
import createRoleReducer from "../modules/account-manaement/roles/redux/slices/create-role-slice";
import editRoleReducer from "../modules/account-manaement/roles/redux/slices/edit-role-slice";
import RolesReducer from "../modules/account-manaement/roles/redux/slices/roles-slice";
import createUserReducer from "../modules/account-manaement/users/redux/slices/createUserSlice";
import editUserReducer from "../modules/account-manaement/users/redux/slices/editUserSlice";
import UserListReducer from "../modules/account-manaement/users/redux/slices/userListSlice";
import Ao3RawDataReducer from "../modules/ao3/redux/slices/ao3-raw-slice";
import issuesReducer from "../modules/bug-reporting/issues_slice";
import { flashMessagesReducer } from "../modules/common/redux/flash-slice";
import { globalPersonalPrefReducer } from "../modules/common/redux/global-pref-slice";
import AutoCompleteReducer from "../modules/consumer-products/amazon-vendor-central/redux/slices/autocomplete-slice";
import AmazonVendorTermPoolListReducer from "../modules/consumer-products/amazon-vendor-central/redux/slices/get-term-pool-list-slice";
import AmazonVendorTermSuggestionsReducer from "../modules/consumer-products/amazon-vendor-central/redux/slices/get-term-suggestions";
import AmazonVendorTimeseriesReducer from "../modules/consumer-products/amazon-vendor-central/redux/slices/get-timeseries-slice";
import AmazonVendorTopCategoriesReducer from "../modules/consumer-products/amazon-vendor-central/redux/slices/get-top-categories-slice";
import AmazonVendorTopProductsReducer from "../modules/consumer-products/amazon-vendor-central/redux/slices/get-top-products-slice";
import WikipediaTopicSearchReducer from "../modules/consumer-products/amazon-vendor-central/redux/slices/wikipedia-topic-search-slice";
import franchiseReducer from "../modules/explore/pages/franchise/redux/franchise_slice";
import talentReducer from "../modules/explore/pages/talent/redux/talent_slice";
import FandomRawDataReducer from "../modules/fandom/redux/slices/fandom-raw-slice";
import googleTrendsRawDataReducer from "../modules/google-trends/redux/slices/google-trends-rawdata-slice";
import { GoogleLeaderBoardReducer } from "../modules/googletrendsv2/redux";
import GeneralGoogleTrendsReducer from "../modules/googletrendsv2/redux/slices/general-googletrends-trends-slice";
import LeaderboardDataReducer from "../modules/home/redux/slices/leaderboard-slice";
import ListOptionsDataReducer from "../modules/home/redux/slices/list-options-slice";
import rankingRawDataReducer from "../modules/home/redux/slices/ranking-rawdata-slice";
import InstagramRawDataReducer from "../modules/instagram/redux/slices/instagram-raw-slice";
import {
  ipManagement,
  pantheonManagement,
} from "../modules/ip_management/redux/slices/ip-management-slice";
import TrendsDataReducer from "../modules/item/redux/slices/general-trends-slice";
import itemAuditDataReducer from "../modules/item/redux/slices/item-audit-slice";
import itemBoxOfficeDataReducer from "../modules/item/redux/slices/item-boxoffice-slice";
import ItemChildrenDataReducer from "../modules/item/redux/slices/item-children-slice";
import itemNewsDataReducer from "../modules/item/redux/slices/item-news-slice";
import ItemDataReducer from "../modules/item/redux/slices/item-slice";
import itemStreamingWindowDataReducer from "../modules/item/redux/slices/item-streamingwindow-slice";
import itemTrailerDataReducer from "../modules/item/redux/slices/item-trailer-slice";
import RedditRawDataReducer from "../modules/reddit/redux/slices/reddit-raw-slice";
import SettingsReducer from "../modules/settings/redux/slices/SettingsReducer";
import CreateNbcuSettingsDataReducer from "../modules/settings/redux/slices/create-nbcu-settings-slice";
import NbcuSettingDataReducer from "../modules/settings/redux/slices/get-nbcu-settings-slice";
import SaveNbcuSettingsDataReducer from "../modules/settings/redux/slices/save-nbcu-settings-slice";
import SettingsNbcuDataReducer from "../modules/settings/redux/slices/settings-nbcu-slice";
// import TarSeriesWikiViewGenreReducer from "../modules/tar/series/wiki/redux/slices/tar-series-wiki-view-genre-slice";
import TiktokRawDataReducer from "../modules/tiktok/redux/slices/tiktok-raw-slice";
import boxOfficeTimeseriesReducer from "../modules/dashboards/box-office/grosstimeseries/redux/slices/box-office-timeseries-slice";
import GoogleRealTimeSearchSavedResponseReducer from "../modules/tools/google-realtime/redux/slices/google-realtime-saved-response-slice";
import TwitterRawDataReducer from "../modules/tools/twitter/redux/slices/twitter-raw-slice";
import WattpadRawDataReducer from "../modules/wattpad/redux/slices/wattpad-raw-slice";
import GeneralWikipediaTrendsReducer from "../modules/wikipedia/redux/slices/general-wikipedia-trends-slice";
import wikiRawDataReducer from "../modules/wikipedia/redux/slices/raw-data-list-slice";

const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "pantheon-",
  whitelist: ["settings"],
};

const rootReducer = combineReducers({
  settings: SettingsReducer,
  userList: UserListReducer,
  organizationsList: OrganizationsReducer,
  rolesList: RolesReducer,
  createUser: createUserReducer,
  createOrg: createOrganizationReducer,
  createRole: createRoleReducer,
  permissionsList: permissionsReducer,
  routesList: routesListReducer,
  generalWikipediaTrendsData: GeneralWikipediaTrendsReducer,
  generalGoogleTrendsData: GeneralGoogleTrendsReducer,
  createPermissionRoute: createPermissioinsRouteReducer,
  ummappedRouteList: ummappedRouteListReducer,
  editPermissionRoute: editPermissioinsRouteReducer,
  editRole: editRoleReducer,
  editOrg: editOrgReducer,
  editUser: editUserReducer,
  googleTrendsRowData: googleTrendsRawDataReducer,
  ipManagement: ipManagement.reducer,
  pantheonManagement: pantheonManagement.reducer,
  leaderboardData: LeaderboardDataReducer,
  settingsNbcuData: SettingsNbcuDataReducer,
  listOptionsData: ListOptionsDataReducer,
  nbcuSetting: NbcuSettingDataReducer,
  saveSaveNbcuSettingsData: SaveNbcuSettingsDataReducer,
  rankingRowData: rankingRawDataReducer,
  createCreateNbcuSettingsData: CreateNbcuSettingsDataReducer,
  fandomRawData: FandomRawDataReducer,
  ao3RawData: Ao3RawDataReducer,
  redditRawData: RedditRawDataReducer,
  wattpadRawData: WattpadRawDataReducer,
  tiktokRawData: TiktokRawDataReducer,
  twitterRawData: TwitterRawDataReducer,
  instagramRawData: InstagramRawDataReducer,
  googleRealtimeSavedRespose: GoogleRealTimeSearchSavedResponseReducer,
  itemData: ItemDataReducer,
  itemChildrenData: ItemChildrenDataReducer,
  generalTrendsData: TrendsDataReducer,
  franchiseData: franchiseReducer,
  talentData: talentReducer,
  issues: issuesReducer,
  googletrendsLeaderBoard: GoogleLeaderBoardReducer,
  wikiRawData: wikiRawDataReducer,
  amazonVendorTimeseries: AmazonVendorTimeseriesReducer,
  amazonVendorTopProducts: AmazonVendorTopProductsReducer,
  amazonVendorTopCategories: AmazonVendorTopCategoriesReducer,
  amazonVendorAutoComplete: AutoCompleteReducer,
  wikipediaTopicSearch: WikipediaTopicSearchReducer,
  amazonVendorTermSuggestions: AmazonVendorTermSuggestionsReducer,
  amazonVendorTermPoolList: AmazonVendorTermPoolListReducer,
  flashMessages: flashMessagesReducer,
  globalPersonalPref: globalPersonalPrefReducer,
  boxOfficeTimeseries: boxOfficeTimeseriesReducer,
  itemAuditData: itemAuditDataReducer,
  itemNewsData: itemNewsDataReducer,
  itemTrailerData: itemTrailerDataReducer,
  itemBoxOfficeData: itemBoxOfficeDataReducer,
  itemStreamingWindowData: itemStreamingWindowDataReducer,
});

export const store = configureStore({
  reducer: persistReducer(rootPersistConfig, rootReducer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
});

export const persistor = persistStore(store);

export const { dispatch } = store;
export const useDispatch = () => useAppDispatch();
